import type React from "react";
import classnames from "classnames";

import {
  TextComponent,
  type TextStyleProps,
  TextWithIcon,
} from "@/base/components/Global";
import type { MarginProps } from "@/base/components/Layout/constants";
import { createUseStyles } from "@/theme";

const useStyles = createUseStyles<MarginProps>(({ color, font, spacing }) => ({
  h1: {
    margin: 0,
    paddingTop: ({ noMargin, noVerticalMargin, noMarginTop }) =>
      noMargin || noVerticalMargin || noMarginTop ? 0 : spacing.s,
    paddingBottom: ({ noMargin, noVerticalMargin, noMarginBottom }) =>
      noMargin || noVerticalMargin || noMarginBottom ? 0 : spacing.s,
    display: "flex",
    fontSize: font.size.x4l,
    fontWeight: font.weight.xxl,
    lineHeight: font.lineHeight.x3l,
    color: color.black,
  },
}));

type H1Props = TextStyleProps &
  MarginProps & {
    children?: React.ReactNode | string;
    className?: string | number | boolean | null;
    prefixIcon?: React.ReactNode;
    suffixIcon?: React.ReactNode;
  };

const H1: React.FC<H1Props> = ({
  children,
  className,
  prefixIcon,
  suffixIcon,
  ...props
}) => {
  const classes = useStyles(props);

  return (
    <h1 className={classnames([classes.h1, className])}>
      <TextComponent {...props}>
        <TextWithIcon prefixIcon={prefixIcon} suffixIcon={suffixIcon}>
          {children}
        </TextWithIcon>
      </TextComponent>
    </h1>
  );
};

export default H1;
